import clsx from 'clsx';
import React from 'react';

interface DatabaseProjectTitleProps {
  className?: string;
  title: string;
}

const DatabaseProjectTitle = ({ className, title }: DatabaseProjectTitleProps) => {
  return (
    <h1
      className={clsx(
        'mx-auto mb-48 mt-0 max-w-[720px] text-center font-suisse-screen text-headline-alt-md text-black sm:text-headline-alt-lg',
        className
      )}
    >
      {title} <span className="text-primary-magenta">Database</span>
    </h1>
  );
};

export default DatabaseProjectTitle;
